/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eg_Available_NowInputs */

const en_eg_available_now = /** @type {(inputs: Eg_Available_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Available Now`)
};

const id_eg_available_now = /** @type {(inputs: Eg_Available_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mis. Tersedia Sekarang`)
};

/** @type {(inputs: Eg_Available_NowInputs) => LocalizedString} */
const es_eg_available_now = en_eg_available_now;

/** @type {(inputs: Eg_Available_NowInputs) => LocalizedString} */
const fr_eg_available_now = en_eg_available_now;

/** @type {(inputs: Eg_Available_NowInputs) => LocalizedString} */
const de_eg_available_now = en_eg_available_now;

/** @type {(inputs: Eg_Available_NowInputs) => LocalizedString} */
const ja_eg_available_now = en_eg_available_now;

/** @type {(inputs: Eg_Available_NowInputs) => LocalizedString} */
const zh_eg_available_now = en_eg_available_now;

/** @type {(inputs: Eg_Available_NowInputs) => LocalizedString} */
const ar_eg_available_now = en_eg_available_now;

/** @type {(inputs: Eg_Available_NowInputs) => LocalizedString} */
const it_eg_available_now = en_eg_available_now;

/** @type {(inputs: Eg_Available_NowInputs) => LocalizedString} */
const ru_eg_available_now = en_eg_available_now;

/** @type {(inputs: Eg_Available_NowInputs) => LocalizedString} */
const pt_eg_available_now = en_eg_available_now;

/** @type {(inputs: Eg_Available_NowInputs) => LocalizedString} */
const ko_eg_available_now = en_eg_available_now;

/**
* | output |
* | --- |
* | "e.g. Available Now" |
*
* @param {Eg_Available_NowInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const eg_available_now = /** @type {((inputs?: Eg_Available_NowInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eg_Available_NowInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eg_available_now(inputs)
	if (locale === "es") return es_eg_available_now(inputs)
	if (locale === "fr") return fr_eg_available_now(inputs)
	if (locale === "de") return de_eg_available_now(inputs)
	if (locale === "ja") return ja_eg_available_now(inputs)
	if (locale === "zh") return zh_eg_available_now(inputs)
	if (locale === "ar") return ar_eg_available_now(inputs)
	if (locale === "id") return id_eg_available_now(inputs)
	if (locale === "it") return it_eg_available_now(inputs)
	if (locale === "ru") return ru_eg_available_now(inputs)
	if (locale === "pt") return pt_eg_available_now(inputs)
	return ko_eg_available_now(inputs)
});